module.exports = __webpack_public_path__ + "img/atomic-bomb.00088e24.png";